export const orientations = {
  landscape: "(orientation: landscape)",
  portrait: "(orientation: portrait)"
};
